let backupDataPostcodes = [
  {
    is_range: true,
    postcode: "3078",
    postcode_end: "3079",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3093",
    postcode_end: "3095",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3101",
    postcode_end: "3111",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3113",
    postcode_end: "3116",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3121",
    postcode_end: "3138",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3096",
    postcode_end: "3097",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3099",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3139",
    postcode_end: "3116",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3154",
    postcode_end: "3139",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3155",
    postcode_end: "3156",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3158",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3159",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3160",
    postcode_end: "3175",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3161",
    postcode_end: "3202",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3204",
    postcode_end: "3207",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3212",
    postcode_end: "3212",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3222",
    postcode_end: "3227",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3335",
    postcode_end: "3338",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3373",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3427",
    postcode_end: "3435",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3442",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3450",
    postcode_end: "3451",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3458",
    postcode_end: "3438",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3460",
    postcode_end: "3463",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3754",
    postcode_end: "3755",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3758",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3777",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3778",
    postcode_end: "3779",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3781",
    postcode_end: "3783",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3785",
    postcode_end: "3789",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3812",
    postcode_end: "3816",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3925",
    postcode_end: "3931",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3950",
    postcode_end: "3978",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "10000",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: true,
    },
  },
  {
    is_range: false,
    postcode: "3831",
    postcode_end: "3816",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3835",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3840",
    postcode_end: "3825",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3842",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3844",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3847",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3850",
    postcode_end: "3851",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3854",
    postcode_end: "3871",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3918",
    postcode_end: "3920",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3922",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3933",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3934",
    postcode_end: "3944",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3945",
    postcode_end: "3944",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3953",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3956",
    postcode_end: "3981",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3962",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3975",
    postcode_end: "3978",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3980",
    postcode_end: "3981",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3228",
    postcode_end: "3232",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3230",
    postcode_end: "3232",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3340",
    postcode_end: "3342",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3345",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3658",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3714",
    postcode_end: "3715",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3717",
    postcode_end: "3632",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3719",
    postcode_end: "3720",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3722",
    postcode_end: "3723",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3750",
    postcode_end: "3751",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3756",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3759",
    postcode_end: "3761",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3765",
    postcode_end: "3767",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3752",
    postcode_end: "3712",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3764",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3770",
    postcode_end: "3766",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3799",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3808",
    postcode_end: "3797",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3363",
    postcode_end: "3342",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3440",
    postcode_end: "3364",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3453",
    postcode_end: "3435",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3515",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3522",
    postcode_end: "3523",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3550",
    postcode_end: "3552",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3555",
    postcode_end: "3556",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3444",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3753",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3791",
    postcode_end: "3793",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3140",
    postcode_end: "3153",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3214",
    postcode_end: "3220",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3355",
    postcode_end: "3356",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3437",
    postcode_end: "3438",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3757",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3763",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: true,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3857",
    postcode_end: "3858",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3910",
    postcode_end: "3913",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3959",
    postcode_end: "3960",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3809",
    postcode_end: "3810",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3036",
    postcode_end: "3068",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3070",
    postcode_end: "3076",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3350",
    postcode_end: "3352",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3446",
    postcode_end: "3448",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3860",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3862",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3869",
    postcode_end: "3871",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3915",
    postcode_end: "3916",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3926",
    postcode_end: "3929",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3930",
    postcode_end: "3931",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3081",
    postcode_end: "3091",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3775",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3795",
    postcode_end: "3797",
    enabled: true,
    days: {
      Monday: false,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3800",
    postcode_end: "3789",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3802",
    postcode_end: "3807",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3818",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3820",
    postcode_end: "3825",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: true,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3000",
    postcode_end: "3006",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3015",
    postcode_end: "3016",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3018",
    postcode_end: "3034",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3008",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3010",
    postcode_end: "3013",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3984",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: false,
    postcode: "3990",
    postcode_end: "9999",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
  {
    is_range: true,
    postcode: "3995",
    postcode_end: "3996",
    enabled: true,
    days: {
      Monday: true,
      Tuesday: false,
      Wednesday: false,
      Thursday: true,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  },
];

let backupDataApi = {
  success: true,
  postcode_success_message: "Yes, we can deliver to you!",
  postcode_error_message:
    "Oops! Something went wrong, please contact our customer service team via our contact page.",
  non_deliverable_warning:
    "It looks like we don't deliver to your postcode. Please contact our customer service team via our contact page to discuss. ",
  select_date_label: "Choose a delivery date",
  enter_postcode_label: "Enter your postcode",
  delivery_lead_time_days: "2",
  cutoff_time_days: "121",
  order_cutoff_time: "17:00",
  excluded_products: [
    { value: 6827866456142, label: "Gift Card" },
    { value: 6837238628430, label: "Gift Card" },
    { value: 6837248688206, label: "Gift card" },
    { value: 6827869503566, label: "A-List Smoothies" },
    { value: 6827869864014, label: "Healthy At Home" },
    { value: 6827869929550, label: "Cleanse At Home" },
  ],
  calendar: [
    {
      type: "global",
      date: "2023-04-25T00:00:00.000Z",
      day: 25,
      month: 3,
      year: 2023,
      id: "20230425",
    },
    {
      type: "global",
      date: "2023-01-01T00:00:00.000Z",
      day: 1,
      month: 0,
      year: 2023,
      id: "20230101",
    },
    {
      type: "global",
      date: "2023-01-26T00:00:00.000Z",
      day: 26,
      month: 0,
      year: 2023,
      id: "20230126",
    },
    {
      type: "global",
      date: "2023-12-25T00:00:00.000Z",
      day: 25,
      month: 11,
      year: 2023,
      id: "20231225",
    },
    {
      type: "global",
      date: "2023-12-26T00:00:00.000Z",
      day: 26,
      month: 11,
      year: 2023,
      id: "20231226",
    },
    {
      type: "global",
      date: "2024-01-01T00:00:00.000Z",
      day: 1,
      month: 0,
      year: 2024,
      id: "20240101",
    },
    {
      type: "global",
      date: "2024-04-25T00:00:00.000Z",
      day: 25,
      month: 3,
      year: 2024,
      id: "20240425",
    },
    {
      type: "global",
      date: "2024-01-26T00:00:00.000Z",
      day: 26,
      month: 0,
      year: 2024,
      id: "20240126",
    },
    {
      type: "global",
      date: "2024-12-25T00:00:00.000Z",
      day: 25,
      month: 11,
      year: 2024,
      id: "20241225",
    },
    {
      type: "global",
      date: "2024-12-26T00:00:00.000Z",
      day: 26,
      month: 11,
      year: 2024,
      id: "20241226",
    },
    {
      type: "qld",
      date: "2023-12-26T00:00:00.000Z",
      day: 26,
      month: 11,
      year: 2023,
      id: "20231226",
    },
    {
      type: "qld",
      date: "2023-10-02T00:00:00.000Z",
      day: 2,
      month: 9,
      year: 2023,
      id: "20231002",
    },
    {
      type: "qld",
      date: "2023-12-27T00:00:00.000Z",
      day: 27,
      month: 11,
      year: 2023,
      id: "20231227",
    },
    {
      type: "qld",
      date: "2023-12-29T00:00:00.000Z",
      day: 29,
      month: 11,
      year: 2023,
      id: "20231229",
    },
    {
      type: "qld",
      date: "2023-12-31T00:00:00.000Z",
      day: 31,
      month: 11,
      year: 2023,
      id: "20231231",
    },
    {
      type: "qld",
      date: "2023-12-30T00:00:00.000Z",
      day: 30,
      month: 11,
      year: 2023,
      id: "20231230",
    },
    {
      type: "qld",
      date: "2024-01-02T00:00:00.000Z",
      day: 2,
      month: 0,
      year: 2024,
      id: "20240102",
    },
    {
      type: "qld",
      date: "2024-01-03T00:00:00.000Z",
      day: 3,
      month: 0,
      year: 2024,
      id: "20240103",
    },
    {
      type: "qld",
      date: "2024-01-01T00:00:00.000Z",
      day: 1,
      month: 0,
      year: 2024,
      id: "20240101",
    },
    {
      type: "qld",
      date: "2024-01-04T00:00:00.000Z",
      day: 4,
      month: 0,
      year: 2024,
      id: "20240104",
    },
    {
      type: "qld",
      date: "2024-01-07T00:00:00.000Z",
      day: 7,
      month: 0,
      year: 2024,
      id: "20240107",
    },
    {
      type: "qld",
      date: "2024-01-08T00:00:00.000Z",
      day: 8,
      month: 0,
      year: 2024,
      id: "20240108",
    },
    {
      type: "qld",
      date: "2023-12-25T00:00:00.000Z",
      day: 25,
      month: 11,
      year: 2023,
      id: "20231225",
    },
    {
      type: "qld",
      date: "2024-01-13T00:00:00.000Z",
      day: 13,
      month: 0,
      year: 2024,
      id: "20240113",
    },
    {
      type: "qld",
      date: "2024-01-15T00:00:00.000Z",
      day: 15,
      month: 0,
      year: 2024,
      id: "20240115",
    },
    {
      type: "qld",
      date: "2023-12-28T00:00:00.000Z",
      day: 28,
      month: 11,
      year: 2023,
      id: "20231228",
    },
    {
      type: "qld",
      date: "2024-01-20T00:00:00.000Z",
      day: 20,
      month: 0,
      year: 2024,
      id: "20240120",
    },
    {
      type: "qld",
      date: "2023-05-01T00:00:00.000Z",
      day: 1,
      month: 4,
      year: 2023,
      id: "20230501",
    },
    {
      type: "qld",
      date: "2024-01-14T00:00:00.000Z",
      day: 14,
      month: 0,
      year: 2024,
      id: "20240114",
    },
    {
      type: "qld",
      date: "2024-01-21T00:00:00.000Z",
      day: 21,
      month: 0,
      year: 2024,
      id: "20240121",
    },
    {
      type: "qld",
      date: "2024-01-28T00:00:00.000Z",
      day: 28,
      month: 0,
      year: 2024,
      id: "20240128",
    },
    {
      type: "qld",
      date: "2024-01-27T00:00:00.000Z",
      day: 27,
      month: 0,
      year: 2024,
      id: "20240127",
    },
    {
      type: "qld",
      date: "2024-01-29T00:00:00.000Z",
      day: 29,
      month: 0,
      year: 2024,
      id: "20240129",
    },
    {
      type: "qld",
      date: "2024-01-06T00:00:00.000Z",
      day: 6,
      month: 0,
      year: 2024,
      id: "20240106",
    },
    {
      type: "qld",
      date: "2024-01-09T00:00:00.000Z",
      day: 9,
      month: 0,
      year: 2024,
      id: "20240109",
    },
    {
      type: "qld",
      date: "2024-01-30T00:00:00.000Z",
      day: 30,
      month: 0,
      year: 2024,
      id: "20240130",
    },
    {
      type: "qld",
      date: "2024-01-05T00:00:00.000Z",
      day: 5,
      month: 0,
      year: 2024,
      id: "20240105",
    },
    {
      type: "qld",
      date: "2024-02-01T00:00:00.000Z",
      day: 1,
      month: 1,
      year: 2024,
      id: "20240201",
    },
    {
      type: "qld",
      date: "2024-02-29T00:00:00.000Z",
      day: 29,
      month: 1,
      year: 2024,
      id: "20240229",
    },
    {
      type: "qld",
      date: "2024-02-02T00:00:00.000Z",
      day: 2,
      month: 1,
      year: 2024,
      id: "20240202",
    },
    {
      type: "qld",
      date: "2024-02-03T00:00:00.000Z",
      day: 3,
      month: 1,
      year: 2024,
      id: "20240203",
    },
    {
      type: "qld",
      date: "2024-02-04T00:00:00.000Z",
      day: 4,
      month: 1,
      year: 2024,
      id: "20240204",
    },
    {
      type: "qld",
      date: "2024-02-05T00:00:00.000Z",
      day: 5,
      month: 1,
      year: 2024,
      id: "20240205",
    },
    {
      type: "qld",
      date: "2024-02-10T00:00:00.000Z",
      day: 10,
      month: 1,
      year: 2024,
      id: "20240210",
    },
    {
      type: "qld",
      date: "2024-02-11T00:00:00.000Z",
      day: 11,
      month: 1,
      year: 2024,
      id: "20240211",
    },
    {
      type: "qld",
      date: "2024-02-12T00:00:00.000Z",
      day: 12,
      month: 1,
      year: 2024,
      id: "20240212",
    },
    {
      type: "qld",
      date: "2024-02-15T00:00:00.000Z",
      day: 15,
      month: 1,
      year: 2024,
      id: "20240215",
    },
    {
      type: "qld",
      date: "2024-02-18T00:00:00.000Z",
      day: 18,
      month: 1,
      year: 2024,
      id: "20240218",
    },
    {
      type: "qld",
      date: "2024-02-23T00:00:00.000Z",
      day: 23,
      month: 1,
      year: 2024,
      id: "20240223",
    },
    {
      type: "qld",
      date: "2024-02-22T00:00:00.000Z",
      day: 22,
      month: 1,
      year: 2024,
      id: "20240222",
    },
    {
      type: "qld",
      date: "2024-02-21T00:00:00.000Z",
      day: 21,
      month: 1,
      year: 2024,
      id: "20240221",
    },
    {
      type: "qld",
      date: "2024-02-20T00:00:00.000Z",
      day: 20,
      month: 1,
      year: 2024,
      id: "20240220",
    },
    {
      type: "qld",
      date: "2024-02-19T00:00:00.000Z",
      day: 19,
      month: 1,
      year: 2024,
      id: "20240219",
    },
    {
      type: "qld",
      date: "2024-02-28T00:00:00.000Z",
      day: 28,
      month: 1,
      year: 2024,
      id: "20240228",
    },
    {
      type: "qld",
      date: "2024-02-06T00:00:00.000Z",
      day: 6,
      month: 1,
      year: 2024,
      id: "20240206",
    },
    {
      type: "qld",
      date: "2024-02-07T00:00:00.000Z",
      day: 7,
      month: 1,
      year: 2024,
      id: "20240207",
    },
    {
      type: "qld",
      date: "2024-02-13T00:00:00.000Z",
      day: 13,
      month: 1,
      year: 2024,
      id: "20240213",
    },
    {
      type: "qld",
      date: "2024-02-25T00:00:00.000Z",
      day: 25,
      month: 1,
      year: 2024,
      id: "20240225",
    },
    {
      type: "qld",
      date: "2024-02-24T00:00:00.000Z",
      day: 24,
      month: 1,
      year: 2024,
      id: "20240224",
    },
    {
      type: "qld",
      date: "2024-03-01T00:00:00.000Z",
      day: 1,
      month: 2,
      year: 2024,
      id: "20240301",
    },
    {
      type: "qld",
      date: "2024-03-07T00:00:00.000Z",
      day: 7,
      month: 2,
      year: 2024,
      id: "20240307",
    },
    {
      type: "qld",
      date: "2024-03-02T00:00:00.000Z",
      day: 2,
      month: 2,
      year: 2024,
      id: "20240302",
    },
    {
      type: "qld",
      date: "2024-03-03T00:00:00.000Z",
      day: 3,
      month: 2,
      year: 2024,
      id: "20240303",
    },
    {
      type: "qld",
      date: "2024-03-04T00:00:00.000Z",
      day: 4,
      month: 2,
      year: 2024,
      id: "20240304",
    },
    {
      type: "qld",
      date: "2024-03-08T00:00:00.000Z",
      day: 8,
      month: 2,
      year: 2024,
      id: "20240308",
    },
    {
      type: "qld",
      date: "2024-03-17T00:00:00.000Z",
      day: 17,
      month: 2,
      year: 2024,
      id: "20240317",
    },
    {
      type: "qld",
      date: "2024-03-18T00:00:00.000Z",
      day: 18,
      month: 2,
      year: 2024,
      id: "20240318",
    },
    {
      type: "qld",
      date: "2024-01-18T00:00:00.000Z",
      day: 18,
      month: 0,
      year: 2024,
      id: "20240118",
    },
    {
      type: "qld",
      date: "2024-03-31T00:00:00.000Z",
      day: 31,
      month: 2,
      year: 2024,
      id: "20240331",
    },
    {
      type: "qld",
      date: "2024-03-26T00:00:00.000Z",
      day: 26,
      month: 2,
      year: 2024,
      id: "20240326",
    },
    {
      type: "qld",
      date: "2024-03-30T00:00:00.000Z",
      day: 30,
      month: 2,
      year: 2024,
      id: "20240330",
    },
    {
      type: "qld",
      date: "2024-03-22T00:00:00.000Z",
      day: 22,
      month: 2,
      year: 2024,
      id: "20240322",
    },
    {
      type: "qld",
      date: "2024-01-11T00:00:00.000Z",
      day: 11,
      month: 0,
      year: 2024,
      id: "20240111",
    },
    {
      type: "qld",
      date: "2024-03-23T00:00:00.000Z",
      day: 23,
      month: 2,
      year: 2024,
      id: "20240323",
    },
    {
      type: "qld",
      date: "2024-03-24T00:00:00.000Z",
      day: 24,
      month: 2,
      year: 2024,
      id: "20240324",
    },
    {
      type: "qld",
      date: "2024-03-29T00:00:00.000Z",
      day: 29,
      month: 2,
      year: 2024,
      id: "20240329",
    },
    {
      type: "qld",
      date: "2024-03-27T00:00:00.000Z",
      day: 27,
      month: 2,
      year: 2024,
      id: "20240327",
    },
    {
      type: "qld",
      date: "2024-01-16T00:00:00.000Z",
      day: 16,
      month: 0,
      year: 2024,
      id: "20240116",
    },
    {
      type: "qld",
      date: "2024-02-09T00:00:00.000Z",
      day: 9,
      month: 1,
      year: 2024,
      id: "20240209",
    },
    {
      type: "qld",
      date: "2024-02-16T00:00:00.000Z",
      day: 16,
      month: 1,
      year: 2024,
      id: "20240216",
    },
    {
      type: "qld",
      date: "2024-02-08T00:00:00.000Z",
      day: 8,
      month: 1,
      year: 2024,
      id: "20240208",
    },
    {
      type: "qld",
      date: "2024-01-22T00:00:00.000Z",
      day: 22,
      month: 0,
      year: 2024,
      id: "20240122",
    },
    {
      type: "qld",
      date: "2024-01-17T00:00:00.000Z",
      day: 17,
      month: 0,
      year: 2024,
      id: "20240117",
    },
    {
      type: "qld",
      date: "2024-01-12T00:00:00.000Z",
      day: 12,
      month: 0,
      year: 2024,
      id: "20240112",
    },
    {
      type: "qld",
      date: "2024-01-26T00:00:00.000Z",
      day: 26,
      month: 0,
      year: 2024,
      id: "20240126",
    },
    {
      type: "qld",
      date: "2024-01-25T00:00:00.000Z",
      day: 25,
      month: 0,
      year: 2024,
      id: "20240125",
    },
    {
      type: "qld",
      date: "2024-02-17T00:00:00.000Z",
      day: 17,
      month: 1,
      year: 2024,
      id: "20240217",
    },
    {
      type: "qld",
      date: "2024-03-11T00:00:00.000Z",
      day: 11,
      month: 2,
      year: 2024,
      id: "20240311",
    },
    {
      type: "qld",
      date: "2024-01-19T00:00:00.000Z",
      day: 19,
      month: 0,
      year: 2024,
      id: "20240119",
    },
    {
      type: "qld",
      date: "2024-02-26T00:00:00.000Z",
      day: 26,
      month: 1,
      year: 2024,
      id: "20240226",
    },
    {
      type: "qld",
      date: "2024-02-27T00:00:00.000Z",
      day: 27,
      month: 1,
      year: 2024,
      id: "20240227",
    },
    {
      type: "qld",
      date: "2024-04-09T00:00:00.000Z",
      day: 9,
      month: 3,
      year: 2024,
      id: "20240409",
    },
    {
      type: "qld",
      date: "2024-04-23T00:00:00.000Z",
      day: 23,
      month: 3,
      year: 2024,
      id: "20240423",
    },
    {
      type: "qld",
      date: "2024-04-02T00:00:00.000Z",
      day: 2,
      month: 3,
      year: 2024,
      id: "20240402",
    },
    {
      type: "qld",
      date: "2024-04-16T00:00:00.000Z",
      day: 16,
      month: 3,
      year: 2024,
      id: "20240416",
    },
    {
      type: "qld",
      date: "2024-04-01T00:00:00.000Z",
      day: 1,
      month: 3,
      year: 2024,
      id: "20240401",
    },
    {
      type: "qld",
      date: "2024-04-30T00:00:00.000Z",
      day: 30,
      month: 3,
      year: 2024,
      id: "20240430",
    },
    {
      type: "qld",
      date: "2024-04-10T00:00:00.000Z",
      day: 10,
      month: 3,
      year: 2024,
      id: "20240410",
    },
    {
      type: "qld",
      date: "2024-04-03T00:00:00.000Z",
      day: 3,
      month: 3,
      year: 2024,
      id: "20240403",
    },
    {
      type: "qld",
      date: "2024-03-16T00:00:00.000Z",
      day: 16,
      month: 2,
      year: 2024,
      id: "20240316",
    },
    {
      type: "qld",
      date: "2024-04-08T00:00:00.000Z",
      day: 8,
      month: 3,
      year: 2024,
      id: "20240408",
    },
    {
      type: "qld",
      date: "2024-03-14T00:00:00.000Z",
      day: 14,
      month: 2,
      year: 2024,
      id: "20240314",
    },
    {
      type: "qld",
      date: "2024-04-15T00:00:00.000Z",
      day: 15,
      month: 3,
      year: 2024,
      id: "20240415",
    },
    {
      type: "qld",
      date: "2024-04-22T00:00:00.000Z",
      day: 22,
      month: 3,
      year: 2024,
      id: "20240422",
    },
    {
      type: "qld",
      date: "2024-04-29T00:00:00.000Z",
      day: 29,
      month: 3,
      year: 2024,
      id: "20240429",
    },
    {
      type: "qld",
      date: "2024-04-24T00:00:00.000Z",
      day: 24,
      month: 3,
      year: 2024,
      id: "20240424",
    },
    {
      type: "qld",
      date: "2024-04-17T00:00:00.000Z",
      day: 17,
      month: 3,
      year: 2024,
      id: "20240417",
    },
    {
      type: "qld",
      date: "2024-04-04T00:00:00.000Z",
      day: 4,
      month: 3,
      year: 2024,
      id: "20240404",
    },
    {
      type: "qld",
      date: "2024-04-11T00:00:00.000Z",
      day: 11,
      month: 3,
      year: 2024,
      id: "20240411",
    },
    {
      type: "qld",
      date: "2024-04-18T00:00:00.000Z",
      day: 18,
      month: 3,
      year: 2024,
      id: "20240418",
    },
    {
      type: "qld",
      date: "2024-03-20T00:00:00.000Z",
      day: 20,
      month: 2,
      year: 2024,
      id: "20240320",
    },
    {
      type: "qld",
      date: "2024-03-15T00:00:00.000Z",
      day: 15,
      month: 2,
      year: 2024,
      id: "20240315",
    },
    {
      type: "qld",
      date: "2024-04-25T00:00:00.000Z",
      day: 25,
      month: 3,
      year: 2024,
      id: "20240425",
    },
    {
      type: "qld",
      date: "2024-04-26T00:00:00.000Z",
      day: 26,
      month: 3,
      year: 2024,
      id: "20240426",
    },
    {
      type: "qld",
      date: "2024-04-19T00:00:00.000Z",
      day: 19,
      month: 3,
      year: 2024,
      id: "20240419",
    },
    {
      type: "qld",
      date: "2024-04-12T00:00:00.000Z",
      day: 12,
      month: 3,
      year: 2024,
      id: "20240412",
    },
    {
      type: "qld",
      date: "2024-04-05T00:00:00.000Z",
      day: 5,
      month: 3,
      year: 2024,
      id: "20240405",
    },
    {
      type: "qld",
      date: "2024-04-06T00:00:00.000Z",
      day: 6,
      month: 3,
      year: 2024,
      id: "20240406",
    },
    {
      type: "qld",
      date: "2024-03-21T00:00:00.000Z",
      day: 21,
      month: 2,
      year: 2024,
      id: "20240321",
    },
    {
      type: "qld",
      date: "2024-04-13T00:00:00.000Z",
      day: 13,
      month: 3,
      year: 2024,
      id: "20240413",
    },
    {
      type: "qld",
      date: "2024-04-20T00:00:00.000Z",
      day: 20,
      month: 3,
      year: 2024,
      id: "20240420",
    },
    {
      type: "qld",
      date: "2024-04-27T00:00:00.000Z",
      day: 27,
      month: 3,
      year: 2024,
      id: "20240427",
    },
    {
      type: "qld",
      date: "2024-04-28T00:00:00.000Z",
      day: 28,
      month: 3,
      year: 2024,
      id: "20240428",
    },
    {
      type: "qld",
      date: "2024-04-21T00:00:00.000Z",
      day: 21,
      month: 3,
      year: 2024,
      id: "20240421",
    },
    {
      type: "qld",
      date: "2024-04-14T00:00:00.000Z",
      day: 14,
      month: 3,
      year: 2024,
      id: "20240414",
    },
    {
      type: "qld",
      date: "2024-04-07T00:00:00.000Z",
      day: 7,
      month: 3,
      year: 2024,
      id: "20240407",
    },
    {
      type: "qld",
      date: "2024-05-01T00:00:00.000Z",
      day: 1,
      month: 4,
      year: 2024,
      id: "20240501",
    },
    {
      type: "qld",
      date: "2024-05-02T00:00:00.000Z",
      day: 2,
      month: 4,
      year: 2024,
      id: "20240502",
    },
    {
      type: "qld",
      date: "2024-05-09T00:00:00.000Z",
      day: 9,
      month: 4,
      year: 2024,
      id: "20240509",
    },
    {
      type: "qld",
      date: "2024-05-16T00:00:00.000Z",
      day: 16,
      month: 4,
      year: 2024,
      id: "20240516",
    },
    {
      type: "qld",
      date: "2024-03-13T00:00:00.000Z",
      day: 13,
      month: 2,
      year: 2024,
      id: "20240313",
    },
    {
      type: "qld",
      date: "2024-05-23T00:00:00.000Z",
      day: 23,
      month: 4,
      year: 2024,
      id: "20240523",
    },
    {
      type: "qld",
      date: "2024-05-30T00:00:00.000Z",
      day: 30,
      month: 4,
      year: 2024,
      id: "20240530",
    },
    {
      type: "qld",
      date: "2024-05-29T00:00:00.000Z",
      day: 29,
      month: 4,
      year: 2024,
      id: "20240529",
    },
    {
      type: "qld",
      date: "2024-05-22T00:00:00.000Z",
      day: 22,
      month: 4,
      year: 2024,
      id: "20240522",
    },
    {
      type: "qld",
      date: "2024-03-19T00:00:00.000Z",
      day: 19,
      month: 2,
      year: 2024,
      id: "20240319",
    },
    {
      type: "qld",
      date: "2024-05-15T00:00:00.000Z",
      day: 15,
      month: 4,
      year: 2024,
      id: "20240515",
    },
    {
      type: "qld",
      date: "2024-05-08T00:00:00.000Z",
      day: 8,
      month: 4,
      year: 2024,
      id: "20240508",
    },
    {
      type: "qld",
      date: "2024-05-07T00:00:00.000Z",
      day: 7,
      month: 4,
      year: 2024,
      id: "20240507",
    },
    {
      type: "qld",
      date: "2024-05-14T00:00:00.000Z",
      day: 14,
      month: 4,
      year: 2024,
      id: "20240514",
    },
    {
      type: "qld",
      date: "2024-03-12T00:00:00.000Z",
      day: 12,
      month: 2,
      year: 2024,
      id: "20240312",
    },
    {
      type: "qld",
      date: "2024-05-21T00:00:00.000Z",
      day: 21,
      month: 4,
      year: 2024,
      id: "20240521",
    },
    {
      type: "qld",
      date: "2024-05-28T00:00:00.000Z",
      day: 28,
      month: 4,
      year: 2024,
      id: "20240528",
    },
    {
      type: "qld",
      date: "2024-05-27T00:00:00.000Z",
      day: 27,
      month: 4,
      year: 2024,
      id: "20240527",
    },
    {
      type: "qld",
      date: "2024-05-20T00:00:00.000Z",
      day: 20,
      month: 4,
      year: 2024,
      id: "20240520",
    },
    {
      type: "qld",
      date: "2024-05-13T00:00:00.000Z",
      day: 13,
      month: 4,
      year: 2024,
      id: "20240513",
    },
    {
      type: "qld",
      date: "2024-05-06T00:00:00.000Z",
      day: 6,
      month: 4,
      year: 2024,
      id: "20240506",
    },
    {
      type: "qld",
      date: "2024-05-03T00:00:00.000Z",
      day: 3,
      month: 4,
      year: 2024,
      id: "20240503",
    },
    {
      type: "qld",
      date: "2024-05-10T00:00:00.000Z",
      day: 10,
      month: 4,
      year: 2024,
      id: "20240510",
    },
    {
      type: "qld",
      date: "2024-05-17T00:00:00.000Z",
      day: 17,
      month: 4,
      year: 2024,
      id: "20240517",
    },
    {
      type: "qld",
      date: "2024-05-24T00:00:00.000Z",
      day: 24,
      month: 4,
      year: 2024,
      id: "20240524",
    },
    {
      type: "qld",
      date: "2024-05-31T00:00:00.000Z",
      day: 31,
      month: 4,
      year: 2024,
      id: "20240531",
    },
    {
      type: "qld",
      date: "2024-05-25T00:00:00.000Z",
      day: 25,
      month: 4,
      year: 2024,
      id: "20240525",
    },
    {
      type: "qld",
      date: "2024-05-18T00:00:00.000Z",
      day: 18,
      month: 4,
      year: 2024,
      id: "20240518",
    },
    {
      type: "qld",
      date: "2024-05-11T00:00:00.000Z",
      day: 11,
      month: 4,
      year: 2024,
      id: "20240511",
    },
    {
      type: "qld",
      date: "2024-05-04T00:00:00.000Z",
      day: 4,
      month: 4,
      year: 2024,
      id: "20240504",
    },
    {
      type: "qld",
      date: "2024-05-05T00:00:00.000Z",
      day: 5,
      month: 4,
      year: 2024,
      id: "20240505",
    },
    {
      type: "qld",
      date: "2024-05-12T00:00:00.000Z",
      day: 12,
      month: 4,
      year: 2024,
      id: "20240512",
    },
    {
      type: "qld",
      date: "2024-05-19T00:00:00.000Z",
      day: 19,
      month: 4,
      year: 2024,
      id: "20240519",
    },
    {
      type: "qld",
      date: "2024-05-26T00:00:00.000Z",
      day: 26,
      month: 4,
      year: 2024,
      id: "20240526",
    },
    {
      type: "qld",
      date: "2024-06-01T00:00:00.000Z",
      day: 1,
      month: 5,
      year: 2024,
      id: "20240601",
    },
    {
      type: "qld",
      date: "2024-06-08T00:00:00.000Z",
      day: 8,
      month: 5,
      year: 2024,
      id: "20240608",
    },
    {
      type: "qld",
      date: "2024-06-15T00:00:00.000Z",
      day: 15,
      month: 5,
      year: 2024,
      id: "20240615",
    },
    {
      type: "qld",
      date: "2024-06-22T00:00:00.000Z",
      day: 22,
      month: 5,
      year: 2024,
      id: "20240622",
    },
    {
      type: "qld",
      date: "2024-06-29T00:00:00.000Z",
      day: 29,
      month: 5,
      year: 2024,
      id: "20240629",
    },
    {
      type: "qld",
      date: "2024-06-02T00:00:00.000Z",
      day: 2,
      month: 5,
      year: 2024,
      id: "20240602",
    },
    {
      type: "qld",
      date: "2024-06-09T00:00:00.000Z",
      day: 9,
      month: 5,
      year: 2024,
      id: "20240609",
    },
    {
      type: "qld",
      date: "2024-06-16T00:00:00.000Z",
      day: 16,
      month: 5,
      year: 2024,
      id: "20240616",
    },
    {
      type: "qld",
      date: "2024-06-23T00:00:00.000Z",
      day: 23,
      month: 5,
      year: 2024,
      id: "20240623",
    },
    {
      type: "qld",
      date: "2024-06-30T00:00:00.000Z",
      day: 30,
      month: 5,
      year: 2024,
      id: "20240630",
    },
    {
      type: "qld",
      date: "2024-06-28T00:00:00.000Z",
      day: 28,
      month: 5,
      year: 2024,
      id: "20240628",
    },
    {
      type: "qld",
      date: "2024-06-21T00:00:00.000Z",
      day: 21,
      month: 5,
      year: 2024,
      id: "20240621",
    },
    {
      type: "qld",
      date: "2024-06-14T00:00:00.000Z",
      day: 14,
      month: 5,
      year: 2024,
      id: "20240614",
    },
    {
      type: "qld",
      date: "2024-06-07T00:00:00.000Z",
      day: 7,
      month: 5,
      year: 2024,
      id: "20240607",
    },
    {
      type: "qld",
      date: "2024-06-06T00:00:00.000Z",
      day: 6,
      month: 5,
      year: 2024,
      id: "20240606",
    },
    {
      type: "qld",
      date: "2024-06-13T00:00:00.000Z",
      day: 13,
      month: 5,
      year: 2024,
      id: "20240613",
    },
    {
      type: "qld",
      date: "2024-06-20T00:00:00.000Z",
      day: 20,
      month: 5,
      year: 2024,
      id: "20240620",
    },
    {
      type: "qld",
      date: "2024-06-27T00:00:00.000Z",
      day: 27,
      month: 5,
      year: 2024,
      id: "20240627",
    },
    {
      type: "qld",
      date: "2024-06-26T00:00:00.000Z",
      day: 26,
      month: 5,
      year: 2024,
      id: "20240626",
    },
    {
      type: "qld",
      date: "2024-06-19T00:00:00.000Z",
      day: 19,
      month: 5,
      year: 2024,
      id: "20240619",
    },
    {
      type: "qld",
      date: "2024-06-12T00:00:00.000Z",
      day: 12,
      month: 5,
      year: 2024,
      id: "20240612",
    },
    {
      type: "qld",
      date: "2024-06-05T00:00:00.000Z",
      day: 5,
      month: 5,
      year: 2024,
      id: "20240605",
    },
    {
      type: "qld",
      date: "2024-06-04T00:00:00.000Z",
      day: 4,
      month: 5,
      year: 2024,
      id: "20240604",
    },
    {
      type: "qld",
      date: "2024-06-11T00:00:00.000Z",
      day: 11,
      month: 5,
      year: 2024,
      id: "20240611",
    },
    {
      type: "qld",
      date: "2024-06-18T00:00:00.000Z",
      day: 18,
      month: 5,
      year: 2024,
      id: "20240618",
    },
    {
      type: "qld",
      date: "2024-06-25T00:00:00.000Z",
      day: 25,
      month: 5,
      year: 2024,
      id: "20240625",
    },
    {
      type: "qld",
      date: "2024-06-24T00:00:00.000Z",
      day: 24,
      month: 5,
      year: 2024,
      id: "20240624",
    },
    {
      type: "qld",
      date: "2024-06-17T00:00:00.000Z",
      day: 17,
      month: 5,
      year: 2024,
      id: "20240617",
    },
    {
      type: "qld",
      date: "2024-06-10T00:00:00.000Z",
      day: 10,
      month: 5,
      year: 2024,
      id: "20240610",
    },
    {
      type: "qld",
      date: "2024-06-03T00:00:00.000Z",
      day: 3,
      month: 5,
      year: 2024,
      id: "20240603",
    },
    {
      type: "qld",
      date: "2024-02-14T00:00:00.000Z",
      day: 14,
      month: 1,
      year: 2024,
      id: "20240214",
    },
    {
      type: "qld",
      date: "2024-01-10T00:00:00.000Z",
      day: 10,
      month: 0,
      year: 2024,
      id: "20240110",
    },
    {
      type: "qld",
      date: "2024-01-23T00:00:00.000Z",
      day: 23,
      month: 0,
      year: 2024,
      id: "20240123",
    },
    {
      type: "qld",
      date: "2024-01-24T00:00:00.000Z",
      day: 24,
      month: 0,
      year: 2024,
      id: "20240124",
    },
    {
      type: "qld",
      date: "2024-03-05T00:00:00.000Z",
      day: 5,
      month: 2,
      year: 2024,
      id: "20240305",
    },
    {
      type: "qld",
      date: "2024-03-06T00:00:00.000Z",
      day: 6,
      month: 2,
      year: 2024,
      id: "20240306",
    },
    {
      type: "qld",
      date: "2024-01-31T00:00:00.000Z",
      day: 31,
      month: 0,
      year: 2024,
      id: "20240131",
    },
    {
      type: "qld",
      date: "2024-03-09T00:00:00.000Z",
      day: 9,
      month: 2,
      year: 2024,
      id: "20240309",
    },
    {
      type: "qld",
      date: "2024-03-10T00:00:00.000Z",
      day: 10,
      month: 2,
      year: 2024,
      id: "20240310",
    },
    {
      type: "qld",
      date: "2024-03-25T00:00:00.000Z",
      day: 25,
      month: 2,
      year: 2024,
      id: "20240325",
    },
    {
      type: "qld",
      date: "2024-03-28T00:00:00.000Z",
      day: 28,
      month: 2,
      year: 2024,
      id: "20240328",
    },
    {
      type: "yearly",
      date: "2023-04-07T00:00:00.000Z",
      day: 7,
      month: 3,
      year: 2023,
      id: "20230407",
    },
    {
      type: "yearly",
      date: "2023-12-24T00:00:00.000Z",
      day: 24,
      month: 11,
      year: 2023,
      id: "20231224",
    },
    {
      type: "yearly",
      date: "2023-12-25T00:00:00.000Z",
      day: 25,
      month: 11,
      year: 2023,
      id: "20231225",
    },
    {
      type: "yearly",
      date: "2023-04-10T00:00:00.000Z",
      day: 10,
      month: 3,
      year: 2023,
      id: "20230410",
    },
    {
      type: "yearly",
      date: "2023-12-26T00:00:00.000Z",
      day: 26,
      month: 11,
      year: 2023,
      id: "20231226",
    },
    {
      type: "yearly",
      date: "2023-12-27T00:00:00.000Z",
      day: 27,
      month: 11,
      year: 2023,
      id: "20231227",
    },
    {
      type: "yearly",
      date: "2023-12-28T00:00:00.000Z",
      day: 28,
      month: 11,
      year: 2023,
      id: "20231228",
    },
    {
      type: "yearly",
      date: "2023-12-31T00:00:00.000Z",
      day: 31,
      month: 11,
      year: 2023,
      id: "20231231",
    },
    {
      type: "yearly",
      date: "2024-01-04T00:00:00.000Z",
      day: 4,
      month: 0,
      year: 2024,
      id: "20240104",
    },
    {
      type: "yearly",
      date: "2024-01-01T00:00:00.000Z",
      day: 1,
      month: 0,
      year: 2024,
      id: "20240101",
    },
    {
      type: "yearly",
      date: "2024-01-05T00:00:00.000Z",
      day: 5,
      month: 0,
      year: 2024,
      id: "20240105",
    },
    {
      type: "yearly",
      date: "2024-01-02T00:00:00.000Z",
      day: 2,
      month: 0,
      year: 2024,
      id: "20240102",
    },
    {
      type: "yearly",
      date: "2024-01-03T00:00:00.000Z",
      day: 3,
      month: 0,
      year: 2024,
      id: "20240103",
    },
    {
      type: "yearly",
      date: "2023-12-29T00:00:00.000Z",
      day: 29,
      month: 11,
      year: 2023,
      id: "20231229",
    },
    {
      type: "yearly",
      date: "2023-12-30T00:00:00.000Z",
      day: 30,
      month: 11,
      year: 2023,
      id: "20231230",
    },
    {
      type: "yearly",
      date: "2024-12-28T00:00:00.000Z",
      day: 28,
      month: 11,
      year: 2024,
      id: "20241228",
    },
    {
      type: "yearly",
      date: "2024-12-27T00:00:00.000Z",
      day: 27,
      month: 11,
      year: 2024,
      id: "20241227",
    },
    {
      type: "yearly",
      date: "2024-12-30T00:00:00.000Z",
      day: 30,
      month: 11,
      year: 2024,
      id: "20241230",
    },
    {
      type: "yearly",
      date: "2024-03-30T00:00:00.000Z",
      day: 30,
      month: 2,
      year: 2024,
      id: "20240330",
    },
    {
      type: "yearly",
      date: "2024-03-29T00:00:00.000Z",
      day: 29,
      month: 2,
      year: 2024,
      id: "20240329",
    },
    {
      type: "yearly",
      date: "2024-03-31T00:00:00.000Z",
      day: 31,
      month: 2,
      year: 2024,
      id: "20240331",
    },
    {
      type: "yearly",
      date: "2024-12-29T00:00:00.000Z",
      day: 29,
      month: 11,
      year: 2024,
      id: "20241229",
    },
    {
      type: "yearly",
      date: "2024-04-01T00:00:00.000Z",
      day: 1,
      month: 3,
      year: 2024,
      id: "20240401",
    },
    {
      type: "yearly",
      date: "2024-12-31T00:00:00.000Z",
      day: 31,
      month: 11,
      year: 2024,
      id: "20241231",
    },
    {
      type: "yearly",
      date: "2024-04-25T00:00:00.000Z",
      day: 25,
      month: 3,
      year: 2024,
      id: "20240425",
    },
    {
      type: "vic",
      date: "2023-06-12T00:00:00.000Z",
      day: 12,
      month: 5,
      year: 2023,
      id: "20230612",
    },
    {
      type: "vic",
      date: "2023-09-29T00:00:00.000Z",
      day: 29,
      month: 8,
      year: 2023,
      id: "20230929",
    },
    {
      type: "vic",
      date: "2023-11-07T00:00:00.000Z",
      day: 7,
      month: 10,
      year: 2023,
      id: "20231107",
    },
    {
      type: "vic",
      date: "2023-03-13T00:00:00.000Z",
      day: 13,
      month: 2,
      year: 2023,
      id: "20230313",
    },
    {
      type: "vic",
      date: "2024-04-10T00:00:00.000Z",
      day: 10,
      month: 3,
      year: 2024,
      id: "20240410",
    },
    {
      type: "vic",
      date: "2024-04-11T00:00:00.000Z",
      day: 11,
      month: 3,
      year: 2024,
      id: "20240411",
    },
    {
      type: "vic",
      date: "2024-04-09T00:00:00.000Z",
      day: 9,
      month: 3,
      year: 2024,
      id: "20240409",
    },
  ],
};
